import { Typography, Button, Grid } from '@mui/material';
import AddTwoToneIcon from '@mui/icons-material/AddTwoTone';
import { useNavigate } from 'react-router';



function CondolancePageHeader() {
  const navigate = useNavigate();

  const handleCondolancePage = () => {
    navigate('/condolance-messages');
  } 
  return (
    <Grid container justifyContent="space-between" alignItems="center">
      <Grid item>
        <Typography variant="h3" component="h3" gutterBottom>
          Condolance 
        </Typography>

      </Grid>
      <Grid item>
        <Button
          sx={{ mt: { xs: 2, md: 0 } }}
          variant="contained"
          onClick={handleCondolancePage}
          startIcon={<AddTwoToneIcon fontSize="small" />}
        >
          Create Condolance
        </Button>
      </Grid>
    </Grid>
  );
}

export default CondolancePageHeader;
